import $ from 'jquery';
import {is_function} from '../../../Helpers/js/simple.functions';
import UI from '../0-ui';

UI.Dropdown = {
  init: function (ref, onchange) {
    $('.dropdown .dropdown-button', ref).click(function () {
      return UI.Dropdown.open($(this).closest('.dropdown'));
    });
    $('.dropdown .dropdown-button', ref).focus(function () {
      return UI.Dropdown.open($(this).closest('.dropdown'));
    });
    $('.dropdown .dropdown-value', ref).click(function () {
      return UI.Dropdown.select($(this), onchange);
    });
  },

  open: function ($dropdown) {
    if ($dropdown.length === 0) return;
    var $menu = $('ul', $dropdown);
    var wasVisible = $menu.is(':visible');

    /* Close all other menus */
    var $dropdowngroup = $dropdown.closest('.dropdown-group');
    UI.Dropdown.close($('.dropdown', $dropdowngroup));

    // Toggle list
    if (!wasVisible) {
      $dropdown.addClass('open');
      $menu.slideDown(100, function () {
        $(document).click(UI.Dropdown.close);
      });
    }
  },

  close: function ($dropdown) {
    if (!$dropdown.length || $dropdown.length === 0) {
      $dropdown = $('.dropdown');
    }
    $(document).unbind('click', UI.Dropdown.close);
    $dropdown.removeClass('open').find('ul').hide();
  },

  select: function (item, onchange) {
    if (!item) return;
    var parent = item.closest('.dropdown');
    var list = item.closest('ul');
    var value = item.attr('value');
    var type = item.attr('type');

    UI.Dropdown.close(parent);

    // Deselect all other
    if (type == 'radio') {
      $('li.selected', list).removeClass('selected');
    } else if (type == 'check');

    item.closest('li').addClass('selected');
    $('input', parent).val(value);

    //change dropdown-status
    if (item.attr('role') != 'default') {
      parent.addClass('has-selection');
    } else {
      parent.removeClass('has-selection');
    }

    // change dropdown-button-text
    var text = item.html();
    if (item.attr('value_text')) text = item.attr('value_text');
    $('.dropdown-label', parent).html(text);

    if (is_function(onchange)) onchange();

    return false;
  },
};
